var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"candle-info"},[_c('div',{staticClass:"candle-info-text"},[_c('h2',[_vm._v(_vm._s(_vm.candleText))])]),_c('div',{staticClass:"candle-info-candle"},[_c('CandleImage',{attrs:{"scale":_vm.scale,"candle":_vm.candle}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }